<div 
    class="sts-show-error-container" 
    app-sts-cms-txt key="{{ key }}" 
    *ngIf="show" 
    [ngClass]="{ 'show' : show }" 
    role="alert">
    {{ description }}
</div>